export default __webpack_public_path__ + "static/media/tips_amount.b37bcccd.png";